var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 72,
    rx: 35.5,
    fill: "#24ACFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.264 54.288C44.0058 54.288 53.1719 40.2192 53.1719 28.0152C53.1719 27.6192 53.1719 27.216 53.1435 26.82C54.9256 25.5096 56.4663 23.8968 57.6875 22.0392C56.0261 22.788 54.2653 23.2776 52.4619 23.4936C54.3647 22.3416 55.7847 20.5272 56.4663 18.3888C54.6771 19.4616 52.7246 20.2248 50.6869 20.628C47.2363 16.9128 41.4711 16.7328 37.8075 20.2248C35.4432 22.4784 34.4421 25.8408 35.1734 29.0448C27.8533 28.6704 21.0302 25.164 16.4081 19.3968C13.9941 23.616 15.2224 29.0088 19.2268 31.7232C17.7784 31.68 16.3584 31.284 15.0946 30.5712C15.0946 30.6072 15.0946 30.6504 15.0946 30.6864C15.0946 35.0784 18.1476 38.8656 22.4005 39.7368C21.0586 40.104 19.6528 40.1616 18.2896 39.8952C19.4824 43.6536 22.8975 46.2312 26.7954 46.3104C23.572 48.8808 19.5889 50.2776 15.4922 50.2704C14.768 50.2704 14.0438 50.2272 13.3267 50.1336C17.4731 52.848 22.3224 54.288 27.264 54.2808",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ff79036925e354950d69a352eda0eb08.svg";
export { ForwardRef as ReactComponent };